<template>
  <el-container>
    <el-main>
      <div style="margin-bottom: 10px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item class="item_font">系统设置</el-breadcrumb-item>
          <el-breadcrumb-item
            ><span class="item_font">黑名单管理</span></el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>
      <div class="searchBox">
        <el-form label-width="0">
          <el-form-item label="">
            <el-input
              size="mini"
              placeholder="输入责任客服"
              suffix-icon="el-icon-search"
              v-model="input1"
              @input="inputNothing"
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button
              type="primary"
              @click="clickSet"
              size="mini"
              class="item_font"
              >设置</el-button
            >
          </el-form-item>
        </el-form>
      </div>

      <div style="width: 100%">
        <el-table
          stripe
          :data="tableData"
          border
          highlight-current-row
          style="width: 100%"
          :header-cell-style="headerStyle"
          :cell-style="cellStyle"
          @row-click="checkHistory"
          :max-height="tableHeight"
        >
          <el-table-column type="index" label="编号" width="80">
          </el-table-column>
          <el-table-column property="blackUserId" label="用户ID" width="200">
          </el-table-column>
          <el-table-column property="realName" label="责任客服" width="150">
          </el-table-column>
          <el-table-column property="createTime" label="操作时间">
          </el-table-column>
          <el-table-column property="liftingTime" label="预计解禁时间">
          </el-table-column>
          <el-table-column property="operate" label="操作" width="150">
            <template slot-scope="scope">
              <el-button @click="cancleBlack(scope)" type="text" size="small"
                >移除</el-button
              >
              <!-- <span @click="cancleBlack(scope)" class="opr">移除</span> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-main>
    <el-footer>
      <div
        style="
          display: flex;
          flex-direction: row;
          width: 60%;
          margin-left: 20%;
          justify-content: space-around;
        "
      >
        <el-pagination
          background
          :pager-count="9"
          :page-size="10"
          layout="prev, pager, next, total"
          :total="total"
          @prev-click="pre"
          @next-click="next"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </el-footer>
    <div v-if="blackMenu == true" class="item_font">
      <el-dialog
        title="黑名单设置"
        :visible.sync="blackMenu"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="30%"
        center
        style="margin-top: 12%"
      >
        <div style="display: flex; margin: 0 auto">
          <el-form :model="item1" :rules="rules">
            <el-form-item
              prop="huihua"
              label="默认解禁时间:"
              label-width="120px"
            >
              <el-input
                v-model.number="item1.endTime"
                type="huihua"
                style="width: 150px"
                size="mini"
              ></el-input>
            </el-form-item>
          </el-form>
          <!-- <div style="line-height: 30px;margin-right: 10px;"><span>默认解禁时间</span></div>
					<div style="width: 100px;">
						<el-input v-model="endTime" autocomplete="off" size="small"></el-input>
					</div> -->
          <div style="line-height: 40px; margin-left: 10px">
            <span>天</span>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="confirmTime">是</el-button>
          <el-button type="primary" @click="blackMenu = false">否</el-button>
        </div>
      </el-dialog>
    </div>
    <div v-if="cancleBlackMenu == true" class="item_font">
      <el-dialog
        title="取消黑名单提示"
        :visible.sync="cancleBlackMenu"
        width="30%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        center
        style="margin-top: 12%"
      >
        <div style="margin-bottom: 15px; text-align: center">
          <i class="el-icon-warning"></i>
          取消黑名单设置后，客户可正常访问网站，进行咨询操作
        </div>
        <div style="text-align: center">你确认要取消黑名单设置吗？</div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="confirmCanle">是</el-button>
          <el-button type="primary" @click="cancleBlackMenu = false"
            >否</el-button
          >
        </div>
      </el-dialog>
    </div>
    <div v-if="history == true">
      <el-dialog
        title="聊天记录"
        :visible.sync="history"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="50%"
        center
      >
        <div style="text-align: left">{{ name }}</div>
        <div style="margin-top: 15px; margin-bottom: 15px; width: 100%">
          <el-input
            size="medium"
            placeholder="搜索"
            suffix-icon="el-icon-search"
            v-model="input2"
            @input="inputNothing2"
          >
          </el-input>
        </div>
        <el-main style="padding: 0">
          <div
            style="height: 450px; margin-top: 20px"
            v-if="historyMessage != null"
          >
            <div
              class="message"
              v-for="(item, index) in historyMessage"
              :key="index"
            >
              <!-- <div style="width: 40px;height: 40px;background-color: #d0d0d0;margin-right: 5px;"><image></image></div> -->
              <div class="item">
                <div
                  v-if="item.origin == 0"
                  style="
                    line-height: 20px;
                    color: #55aaff;
                    font-size: 12px;
                    font-weight: bold;
                  "
                >
                  {{ item.nickName }}
                </div>
                <div
                  v-if="item.origin == 1"
                  style="
                    line-height: 20px;
                    color: #000000;
                    font-size: 12px;
                    font-weight: bold;
                  "
                >
                  {{ item.roleName }}
                </div>
                <div
                  v-if="item.type == 'text'"
                  style="line-height: 20px"
                  class="historyContext"
                  :title="item.content"
                >
                  {{ item.content }}
                </div>
                <div v-if="item.type == 'image'">
                  <img :src="item.content" />
                </div>
                <div v-if="item.type == 'audio'">
                  <audio :src="item.content"></audio>
                </div>
                <div class="time">{{ item.timestamp }}</div>
              </div>
            </div>
          </div>
        </el-main>
        <el-footer>
          <div class="pagenation">
            <el-pagination
              background
              :pager-count="5"
              :page-size="10"
              layout="prev, pager, next, total"
              :total="historyMessageTotal"
              @prev-click="pre1"
              @next-click="next1"
              @current-change="handleCurrentChange1"
            >
            </el-pagination>
          </div>
        </el-footer>
        <!-- <div slot="footer" class="dialog-footer">
					<el-button @click="history = false">取 消</el-button>
					<el-button type="primary" @click="history = false">确 定</el-button>
				</div> -->
      </el-dialog>
    </div>
  </el-container>
</template>

<script>
import $ from "jquery";

export default {
  data() {
    var timeCheck = (rule, value, callback) => {
      console.log(this.item1.endTime, typeof this.item1.endTime);
      if (typeof this.item1.endTime != "number") {
        callback(new Error("请输入数字"));
      } else {
        if (this.item1.endTime <= 0) {
          callback(new Error("请输入大于0的正整数"));
        } else {
          callback();
        }
      }
    };
    return {
      tableData: [],
      input1: "",
      totalPage: 180,
      blackMenu: false,
      cancleBlackMenu: false,
      history: false,
      endTime: "",
      index: "",
      realName: "",
      currentMenu: "",
      start: 0,
      page: 1,
      total: 0,
      name: "",
      historyMessage: [],
      value: "",
      historyMessageTotal: 0,
      historyPage: 1,
      historyValue: "",
      input2: "",
      cid: "",
      csid: "",
      item1: {
        endTime: "",
      },
      rules: {
        huihua: [
          { type: "number", message: "最大会话数必须为数字" },
          { validator: timeCheck, trigger: "blur" },
        ],
      },
      tableHeight: 400,
    };
  },
  mounted() {
    let self = this;
    document.onkeydown = function (e) {
      let ev = document.all ? window.event : e;
      if (ev.keyCode === 13) {
        self.blackMenuLst();
      }
    };
    // const account = JSON.parse(localStorage.getItem("account"));
    // this.realName = account.realName
    this.blackMenuLst();
    this.blackMenuMiniTime();
    this.$nextTick(() => {
      var seaH = $(".searchBox").height();
      this.tableHeight = window.innerHeight - seaH - 180;
      window.addEventListener("resize", () => {
        //监听浏览器窗口大小改变
        //浏览器变化执行动作
        var seaH = $(".searchBox").height();
        this.tableHeight = window.innerHeight - seaH - 180;
      });
    });
  },
  methods: {
    async blackMenuMiniTime() {
      var api = "/manager/blacklist/selectDefaultTime";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {},
      });
      console.log("blackMenuMiniTime response = ", response.data);
      this.item1.endTime = response.data.day;
    },
    async blackMenuLst() {
      var api = "/manager/blacklist/select";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          current: this.page,
          realName: this.realName,
          size: 10,
        },
      });
      console.log("blackMenuLst response = ", response.data);
      this.total = response.data.total;
      this.tableData = response.data.blacklistVoList;
      for (var i = 0; i < this.tableData.length; i++) {
        if (
          this.tableData[i].createTime != null ||
          this.tableData[i].createTime != undefined
        ) {
          var create = this.util.timeStampToDate(
            this.tableData[i].createTime,
            0
          );
          this.tableData[i].createTime = create;
        }
        if (
          this.tableData[i].liftingTime != null ||
          this.tableData[i].liftingTime != undefined
        ) {
          var lift = this.util.timeStampToDate(
            this.tableData[i].liftingTime,
            0
          );
          this.tableData[i].liftingTime = lift;
        }
      }
      console.log("时间转换", this.tableData);
    },
    async addDefaultTime() {
      var api = "/manager/blacklist/AddDefaultTime";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          day: this.item1.endTime,
        },
      });
      console.log("AddDefaultTime response = ", response.data);
      if (response.resultCode === "10000") {
        this.open1("设置成功");
      } else {
        this.open2(response.desc);
      }
    },
    async blackMenuLstDel() {
      var api = "/manager/blacklist/del";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          id: this.currentMenu.id,
        },
      });
      console.log("blackMenuLstDel response = ", response.data);
      this.blackMenuLst();
      if (response.resultCode === "10000") {
        this.open1("移除成功");
      } else {
        this.open2(response.desc);
      }
    },
    async chatRecord() {
      var api = "/manager/blacklist/selectDetail";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          csid: this.csid,
          current: this.historyPage,
          content: this.historyValue,
          size: 10,
          cid: this.cid,
        },
      });
      console.log("chatRecord response = ", response.data);
      this.historyMessage = response.data.chatMessageList;
      this.historyMessageTotal = response.data.total;
      if (this.historyMessage != null) {
        for (var i = 0; i < this.historyMessage.length; i++) {
          if (
            this.historyMessage[i].timestamp != null ||
            this.historyMessage[i].timestamp != undefined
          ) {
            var end = this.util.timeStampToDate(
              this.historyMessage[i].timestamp,
              0
            );
            this.historyMessage[i].timestamp = end;
          }
        }
      }
    },
    headerStyle({ rowIndex, columnIndex }) {
      if (rowIndex == 0 && columnIndex == 5) {
        return "text-align:center;color:#000000";
      } else {
        return "text-align:left;padding:15px;color:#000000";
      }
    },
    cellStyle({ columnIndex }) {
      if (columnIndex == 5) {
        return "text-align:center";
      } else {
        return "text-align:left;padding:15px;";
      }
    },
    clickSet() {
      this.blackMenuMiniTime();
      this.blackMenu = !this.blackMenu;
    },
    cancleBlack(scope) {
      this.index = scope.$index;
      this.currentMenu = this.tableData[scope.$index];
      this.cancleBlackMenu = !this.cancleBlackMenu;
    },
    confirmTime() {
      // console.log(typeOf(this.endTime))
      if (this.item1.endTime === "") {
        this.open2(" 默认解禁时间不能为空 ");
      } else if (!/(^[1-9]\d*$)/.test(this.item1.endTime)) {
        this.open2(" 默认解禁时间必须为正整数 ");
      } else {
        this.blackMenu = false;
        this.addDefaultTime();
      }
    },
    checkHistory(row, column, event) {
      console.log("*** checkHistory ***", row);
      console.log("@@@ checkHistory @@@", column.label);
      console.log("### checkHistory ###", event);
      this.name = row.blackUserName;
      this.cid = row.blackUserId;
      this.csid = row.id;
      this.chatRecord();
      if (column.label != "操作") {
        this.history = !this.history;
      }
    },
    confirmCanle() {
      this.cancleBlackMenu = false;
      this.blackMenuLstDel();
    },
    querySearch(queryString, cb) {
      var restaurants = this.tableData;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      console.log("查询结果", queryString, results);
      if (results.length == 0) {
        results = [{ realName: "未搜索到数据" }];
      }
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (tableData) => {
        return (
          tableData.realName
            .toLowerCase()
            .indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    inputNothing(val) {
      console.log("输入值发生改变", val);
      this.value = val;
      if (val == "") {
        this.realName = "";
        this.page = 1;
        this.blackMenuLst();
      } else {
        this.realName = this.value;
        this.blackMenuLst();
      }
    },
    inputNothing2(val) {
      console.log("输入值发生改变", val);
      this.historyValue = val;
      if (val == "") {
        this.historyPage = 1;
        this.historyValue = "";
      } else {
        this.historyValue = val;
      }
      this.chatRecord();
    },
    handleSelect() {
      this.realName = this.value;
      this.blackMenuLst();
    },
    pre(info) {
      console.log("pre：", info);
      this.page = info;
      this.blackMenuLst();
    },
    next(info) {
      console.log("next：", info);
      this.page = info;
      this.blackMenuLst();
    },
    handleCurrentChange(val) {
      this.start = 4 * (val - 1);
      console.log("当前页码：", val, this.start);
      this.page = val;
      this.blackMenuLst();
    },
    pre1(info) {
      console.log("pre：", info);
      this.historyPage = info;
      this.chatRecord();
    },
    next1(info) {
      console.log("next：", info);
      this.historyPage = info;
      this.chatRecord();
    },
    handleCurrentChange1(val) {
      console.log("当前页码：", val);
      this.historyPage = val;
      this.chatRecord();
    },
    open1(info) {
      // const text = '保存成功'
      console.log(info);
    },
    open2(info) {
      const text = info + " 保存失败 ";
      this.$message.error(text);
    },
  },
};
</script>

<style>
.top1 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 15px;
  width: 90%;
}
.dialog {
  width: 600px;
}
.opr {
  width: 40px;
  line-height: 20px;
  font-size: 12px;
  color: #35b9ff;
  cursor: pointer;
}
.message {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  text-align: left;
  padding-top: 5px;
  border-bottom: 1px solid #d8d8d8;
}
.item {
  display: flex;
  flex-direction: column;
  width: 100%;
  color: #6f6f6f;
}
.historyContext {
  white-space: normal;
  word-break: break-all;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
}
.time {
  text-align: right;
  width: 100%;
  min-width: 140px;
  font-size: 12px;
}
.pagenation {
  display: flex;
  flex-direction: row;
  width: 60%;
  margin-left: 20%;
  justify-content: space-around;
}
.el-breadcrumb-item {
  @include change_size($font_size_normal);
}
</style>
